<template>

    <div class="flex flex-col mt-5 mt-10 mb-12">

        <div class="flex justify-between pt-6 pb-7 px-6 bg-white rounded-t-xl shadow"
            :class="{
                'border-b border-gray-200': is_border
            }">

            <h3 class="text-lg font-medium text-gray-900 flex items-end">

                <slot name="title"></slot>

            </h3>

        </div>


        <form @submit.prevent="$emit('submitted')">

            <div class="px-6 py-12 bg-white shadow"
                :class="{
                    'rounded-b-xl': ! has_actions
                }">

                <div :class="form_class"
                    :style="form_style">

                    <slot name="form"></slot>

                </div>

            </div>


            <div class="flex items-center justify-start px-6 py-4 bg-gray-50 text-right rounded-b-xl shadow"
                v-if="has_actions">

                <slot name="actions"></slot>

            </div>

        </form>

    </div>

</template>

<script>

import { defineComponent } from 'vue'

export default defineComponent({

    emits: [
        'submitted'
    ],

    props: {
        is_border: {
            type: Boolean,
            default: true
        },
        form_class: {
            type: String,
            default: 'grid gap-6 grid-cols-6 gap-y-8'
        },
        form_style: {
            type: String,
            default: ''
        }
    },

    computed: {

        has_actions() {
            return !! this.$slots.actions
        },
    }
});

</script>
